import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useSurveyId } from './useSurveyId'

const document = graphql(`
  mutation SurveySettingsPage_UpdateSurvey(
    $surveyId: ID!
    $title: String
    $metadata: SurveyMetadataInput
  ) {
    updateSurvey(id: $surveyId, title: $title, metadataInput: $metadata) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useUpdateSurveyMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Omit<Variables, 'surveyId'>, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const surveyId = useSurveyId()

  return useMutation({
    mutationFn: (variables) =>
      graphQLRequest({ document, variables: { ...variables, surveyId } }),
    ...options,
  })
}
